enum DataName {
  ADMINISTRATION = "administration",
  BUSINESS = "business",
  CATALOGUE = "catalogue"
}

export default DataName;